import TicketSelector from './TicketSelector';
import ajax from '../../utils/ajax';
import serialize from '../../utils/form/serialize';
import disableForm from '../../utils/form/disableForm';
import StaticBestAvailable from './components/StaticBestAvailable';
import { stringifySpecialRequests } from './TicketSelectorUtils';
import getCustomFormControls from '../../utils/form/getCustomFormControls';

/** @typedef {import('../../tnew/lib/FieldValidationProvider').default} FieldValidationProviderInstance */
/** @typedef {import('./types').PerformanceConfiguration} PerformanceConfiguration */
/** @typedef {import('./types').TicketSelectorOptions} TicketSelectorOptions */

const FieldValidationProvider = window.tnew.lib.FieldValidationProvider;
const Messaging = window.tnew.ui.messaging;


const ResponseTypes = {
  Success: 'Success',
  Error: 'Error',
  ValidationError: 'ValidationError',
};


class EventsDetailTicketSelector extends TicketSelector {
  /**
   * @param {HTMLFormElement} $form
   * @param  {TicketSelectorOptions} options
   * @param {PerformanceConfiguration} performanceConfiguration
   * @param {FieldValidationProviderInstance} validationProvider
   */
  constructor($form, options, performanceConfiguration, validationProvider) {
    super($form, options);

    this.performanceConfiguration = performanceConfiguration;
    this.validationProvider = validationProvider;
  }

  onFormSubmit(event) {
    event.preventDefault();

    this.submitData();
  }

  submitData = async () => {
    Messaging.clearErrors();

    const pricetypeQuantities = this.pricetypeQuantities.getAllPricetypeQuantities()
      .filter(el => el.quantity > 0);

    const totalQuantity = pricetypeQuantities.reduce((total, el) => total + el.quantity, 0);

    const specialRequests = this.getSpecialRequests(totalQuantity);

    const zoneId = this.zones.getSelectedZoneId();

    const postData = Object.assign({}, this.performanceConfiguration, {
      zoneId,
      ticketReservationRequests: pricetypeQuantities,
      specialRequests: stringifySpecialRequests(specialRequests),
      customForm: this.getCustomFormData(),
    });

    const { reenableForm } = disableForm(this.form);

    let errorMessage;

    try {
      const response = await ajax.postWithRequestVerificationToken('/api/tickets/reservation', postData);

      switch (response.type) {
        case ResponseTypes.Success:
          window.location.href = response.redirectLocation;
          return;

        case ResponseTypes.ValidationError:
          errorMessage = response.message;

          this.validationProvider.applyValidationResults(response.validationResult);
          break;

        case ResponseTypes.Error:
          errorMessage = response.message;
          break;

        default:
          throw new Error();
      }
    } catch (e) {
      errorMessage = StaticBestAvailable.reservationErrorMessage;
    }

    if (errorMessage) {
      Messaging.addError(errorMessage, true);
    }

    reenableForm();

    FieldValidationProvider.focusFirstError();
  }

  getCustomFormData() {
    const $controls = getCustomFormControls(this.form);

    const data = serialize($controls);

    return Object.entries(data)
      .map(([key, value]) => ({ key, value }));
  }
}

export default EventsDetailTicketSelector;



// WEBPACK FOOTER //
// ./src/events/detail/EventsDetailTicketSelector.js